<form [formGroup]="priceCalculatorForm">
  <div class="row">
    <!-- Milage -->
    <div class="col-12 duration">
      <label class="form-label">Select Annual Mileage (km)</label>
    </div>
    <div class="col-12 duration">
      <!-- <input formControlName="mileage" (change)="calculateMileage()" type="range" class="form-range" [min]="mileageMin"
        [max]="mileageMax" id="mileage"> -->
      <ngx-slider *ngIf="isBrowser" (valueChange)="onMileageChange($event)" [options]="mileageOption"></ngx-slider>
    </div>
    <div class="col-12 duration d-flex justify-content-between">
      <span *ngFor="let mileage of mileageOptions">{{mileage | number:'.0'}} km</span>
    </div>
    <!-- Duration -->
    <div class="col-12 duration tw-pt-4">
      <label class="form-label">Select Duration (month)</label>
    </div>
    <div class="col-12 duration">
      <!-- <input formControlName="tenure" (change)="calculateTenure()" type="range" class="form-range" [min]="0"
        [max]="tenureMax" id="tenure"> -->
      <ngx-slider *ngIf="isBrowser" [value]="tenureMax" (valueChange)="onTenureChange($event)"
        [options]="tenureOption"></ngx-slider>
    </div>
    <div class="col-12 duration d-flex justify-content-between">
      <span *ngFor="let tenure of tenureOptions ">{{tenure}} months</span>
    </div>
    <!-- Price -->
    <div class="col-12 tw-flex price">
      <app-pricing-view class="tw-flex-1" [originalPrice]="originalPrice" [discountedPrice]="discountedPrice">
      </app-pricing-view>
      <div class="tw-flex-row tw-justify-center tw-items-center">
        <p class="save tw-w-max tw-py-1 tw-px-2 tw-text-pinkDark tw-rounded-full tw-border tw-border-pinkDark">
          Save {{discountedPrice*30/100 | prettyPrice}}
        </p>

        <div class="tw-flex-1 tw-mt-1 tw-flex tw-justify-evenly">
          <a (click)="navigateTo('corporate-lease')" class="btn-link">See how</a>
          <fa-icon class="btn-link" [icon]="faArrowRight"></fa-icon>
        </div>
      </div>
    </div>
  </div>
</form>